<script lang="ts">
  export let width: number = 130;
  export let height: number = 80;
  export let className: string = "";
  // Font Awesome solid icons
  export let bikeClass: string = "fa-solid fa-bicycle";
  export let mountainClass: string = "fa-solid fa-mountain-sun";

  export let distanceText: string;

</script>

<div class="relative" style={`width:${width}px;height:${height}px;`}>
  <svg
    {width}
    {height}
    viewBox="0 0 130 80"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Tour De France passport stamp"
    class={className}
  >
    <title>Tour De France Passport Stamp</title>

    <!-- Top edge perforations (dots) -->
    <path d="M 18 26 L 112 26" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-dasharray="0.4 4" opacity="0.85" />

    <!-- Main ribbon banner (inverted notches) -->
    <path
      d="M 6 30 L 124 30 L 128 40 L 124 50 L 6 50 L 2 40 Z"
      fill="none"
      stroke="#000"
      stroke-width="1.8"
    />
    <!-- Inner outline -->
    <path
      d="M 8 32 L 122 32 L 125 40 L 122 48 L 8 48 L 5 40 Z"
      fill="none"
      stroke="#000"
      stroke-width="0.9"
      opacity="0.95"
    />

    <!-- Subtle skyline silhouette panel (black-only, low opacity) -->
    <path
      d="M 20 56 C 32 52, 36 58, 44 55 C 52 52, 60 58, 68 54 C 76 50, 84 58, 92 54 C 98 51, 106 57, 112 53 L 112 64 L 20 64 Z"
      fill="#000"
      opacity="0.08"
    />

    <!-- Meandering route with stage chevrons -->
    <!-- <path d="M 26 44 C 38 41, 52 47, 64 43 C 76 39, 92 45, 108 41" fill="none" stroke="#000" stroke-width="1.2" stroke-dasharray="3 2" opacity="0.85" />
    <path d="M 54 42 L 56 44 L 54 46" fill="none" stroke="#000" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M 86 40 L 88 42 L 86 44" fill="none" stroke="#000" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /> -->

    <!-- Title on the main banner -->
    <g transform="translate(65,40)">
      <text x="0" y="4" fill="#000" font-size="11" font-weight="900" text-anchor="middle" style="letter-spacing:1.5px;paint-order:stroke fill;stroke:#000;stroke-width:0.7;">TOUR DE FRANCE</text>
    </g>

    <!-- Secondary mini-banner for distance -->
    <path d="M 42 54 L 88 54 L 92 60 L 88 64 L 42 64 L 38 60 Z" fill="none" stroke="#000" stroke-width="1.2" />
    <g transform="translate(65,63)">
      <text x="0" y="-1" fill="#000" font-size="8" font-weight="700" text-anchor="middle" style="letter-spacing:1px;">{distanceText}</text>
    </g>
  </svg>

  <!-- FA overlays -->
  <!-- Bicycle centered on the main banner -->
  <div class="absolute" style="top:12px;left:40%;transform:translateX(-50%);color:#000;">
    <i class={bikeClass} style="font-size:18px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>

  <!-- Mountain-sun toward the higher mountains section (right side) -->
  <div class="absolute" style="top:20px;left:92px;transform:translate(-50%, -50%);color:#000;">
    <i class={mountainClass} style="font-size:18px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>
</div>
